import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: 'Sipariş',
      questions: [
        {
          q: 'Siparişimi nasıl verebilirim?',
          a: 'Sitemizden istediğiniz ürünleri sepete ekleyerek sipariş verebilirsiniz. Sepetinizdeki ürünleri gözden geçirdikten sonra "Siparişi Tamamla" butonuna tıklayarak bilgilerinizi doldurup siparişinizi tamamlayabilirsiniz.'
        },
        {
          q: 'Siparişimi nasıl takip edebilirim?',
          a: 'Siparişinizi "Siparişlerim" sayfasından takip edebilirsiniz. Siparişiniz kargoya verildikten sonra size gönderilen takip numarası ile de kargo durumunu takip edebilirsiniz.'
        },
        {
          q: 'Siparişimi iptal edebilir miyim?',
          a: 'Siparişiniz henüz kargoya verilmediyse iptal edebilirsiniz. Bunun için müşteri hizmetlerimizle iletişime geçmeniz gerekmektedir.'
        },
        {
          q: 'Siparişim ne zaman kargoya verilir?',
          a: 'Siparişleriniz genellikle 1-2 iş günü içinde kargoya verilir. Hafta sonları ve resmi tatillerde kargo işlemleri yapılmaz.'
        }
      ]
    },
    {
      category: 'Kargo ve Teslimat',
      questions: [
        {
          q: 'Kargo ücreti ne kadar?',
          a: '300 TL ve üzeri siparişlerde kargo ücretsizdir. 300 TL altındaki siparişlerde standart kargo ücreti 50 TL\'dir. İstanbul içi hızlı teslimat için 249 TL ücret alınır.'
        },
        {
          q: 'Siparişim ne zaman elime ulaşır?',
          a: 'Standart teslimat 1-3 iş günü, İstanbul içi hızlı teslimat ise 1-2 saat içinde gerçekleşir. Kargo takip numaranız ile siparişinizin konumunu takip edebilirsiniz.'
        },
        {
          q: 'Kargo takip numarasını nasıl alırım?',
          a: 'Siparişiniz kargoya verildikten sonra, kargo takip numaranız e-posta adresinize gönderilir. Ayrıca "Siparişlerim" sayfasından da takip numaranızı görebilirsiniz.'
        },
        {
          q: 'Adres değişikliği yapabilir miyim?',
          a: 'Siparişiniz henüz kargoya verilmediyse adres değişikliği yapabilirsiniz. Bunun için müşteri hizmetlerimizle iletişime geçmeniz gerekmektedir.'
        }
      ]
    },
    {
      category: 'İade ve Değişim',
      questions: [
        {
          q: 'İade için ne kadar sürem var?',
          a: 'Ürünü teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz. Ürünün kutusu açılmamış, hasar görmemiş ve kullanılmamış olması gerekmektedir.'
        },
        {
          q: 'İade ücreti kim tarafından ödenir?',
          a: 'Ürün hatası veya yanlış ürün gönderimi durumunda iade kargo ücreti tarafımızca karşılanır. Müşteri kaynaklı iadelerde kargo ücreti müşteriye aittir.'
        },
        {
          q: 'Para iadesi ne zaman hesabıma geçer?',
          a: 'Ürün kontrol edilip onaylandıktan sonra, ödeme yönteminize göre 1-7 iş günü içinde para iadeniz gerçekleştirilir.'
        },
        {
          q: 'Ürünü değiştirebilir miyim?',
          a: 'Evet, ürün değişimi yapabilirsiniz. Bunun için önce mevcut ürünü iade etmeniz, sonra istediğiniz ürünü sipariş etmeniz gerekmektedir.'
        }
      ]
    },
    {
      category: 'Ödeme',
      questions: [
        {
          q: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
          a: 'Kredi kartı ve banka kartı ile güvenli ödeme kabul ediyoruz. Tüm ödemeler iyzico güvenli ödeme altyapısı üzerinden gerçekleştirilir.'
        },
        {
          q: 'Ödeme güvenliği nasıl sağlanıyor?',
          a: 'Tüm ödemeler SSL şifreleme teknolojisi ile korunur ve kredi kartı bilgileriniz saklanmaz. Ödeme işlemleri iyzico güvenli ödeme altyapısı üzerinden gerçekleştirilir.'
        },
        {
          q: 'Fatura alabilir miyim?',
          a: 'Evet, siparişinizle birlikte fatura gönderilir. Fatura bilgilerinizi sipariş sırasında belirtebilirsiniz.'
        }
      ]
    },
    {
      category: 'Hesap ve Üyelik',
      questions: [
        {
          q: 'Hesap oluşturmak zorunda mıyım?',
          a: 'Hayır, misafir olarak da sipariş verebilirsiniz. Ancak hesap oluşturmanız sipariş takibi ve diğer avantajlar için önerilir.'
        },
        {
          q: 'Şifremi unuttum, ne yapmalıyım?',
          a: 'Giriş sayfasındaki "Şifremi Unuttum" linkine tıklayarak e-posta adresinize şifre sıfırlama linki gönderebilirsiniz.'
        },
        {
          q: 'Hesap bilgilerimi nasıl güncelleyebilirim?',
          a: 'Hesabınıza giriş yaptıktan sonra "Profil" sayfasından tüm bilgilerinizi güncelleyebilirsiniz.'
        }
      ]
    },
    {
      category: 'Ürünler',
      questions: [
        {
          q: 'Ürünleriniz orijinal mi?',
          a: 'Evet, sattığımız tüm ürünler orijinal ve garantilidir. Ürünleriniz resmi distribütörlerden temin edilir.'
        },
        {
          q: 'Ürün garantisi var mı?',
          a: 'Evet, tüm ürünlerimiz üretici garantilidir. Garanti süresi ürün kategorisine göre değişiklik göstermektedir.'
        },
        {
          q: 'Stokta olmayan ürünleri satın alabilir miyim?',
          a: 'Stokta olmayan ürünler için ön sipariş verebilirsiniz. Ürün stoklarımıza geldiğinde size bilgi verilir.'
        }
      ]
    }
  ];

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Sık Sorulan Sorular
          </h1>
          <p className="text-xl text-gray-600">
            Merak ettiğiniz soruların cevaplarını burada bulabilirsiniz
          </p>
        </div>

        {/* FAQ Categories */}
        <div className="space-y-8">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-orange-500 px-6 py-4">
                <h2 className="text-xl font-bold text-white">{category.category}</h2>
              </div>
              <div className="divide-y divide-gray-200">
                {category.questions.map((faq, questionIndex) => {
                  const index = `${categoryIndex}-${questionIndex}`;
                  const isOpen = openIndex === index;
                  return (
                    <div key={questionIndex} className="border-b border-gray-200 last:border-b-0">
                      <button
                        onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                      >
                        <span className="font-semibold text-gray-900 pr-4">{faq.q}</span>
                        {isOpen ? (
                          <ChevronUp className="h-5 w-5 text-gray-500 flex-shrink-0" />
                        ) : (
                          <ChevronDown className="h-5 w-5 text-gray-500 flex-shrink-0" />
                        )}
                      </button>
                      {isOpen && (
                        <div className="px-6 pb-4 bg-gray-50">
                          <p className="text-gray-700 leading-relaxed">{faq.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* İletişim CTA */}
        <div className="mt-12 bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg shadow-md p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Aradığınız cevabı bulamadınız mı?
          </h2>
          <p className="text-gray-700 mb-6">
            Müşteri hizmetlerimizle iletişime geçerek daha detaylı bilgi alabilirsiniz.
          </p>
          <a
            href="/contact"
            className="inline-block bg-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors"
          >
            Bize Ulaşın
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;








